<template>
    <div class="container flex flex-direction">
        <dv-loading v-if="loading" class="loading">Loading...</dv-loading>
        <div class="header-container flex align-center justify-between">
            <div class="flex align-center">
                <!--                <div class="btn-container" @click="$router.go(-1)">-->
                <!--                    <div class="btn"><i class="iconfont icon-fanhui margin-right-xs"></i>返回</div>-->
                <!--                </div>-->
                <el-dropdown class="xiaoqu" trigger="click" @command="handleCommand" v-if="user.power === 3">
                    <div class="btn-container mid">
                        <div class="btn">
                            {{ project_name || '全部社区' }}<i class="el-icon-arrow-down el-icon--right"></i>
                        </div>
                    </div>
                    <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item v-for="(item,index) in projects" :key="index" :command="item">{{ item.name }}
                        </el-dropdown-item>
                    </el-dropdown-menu>
                </el-dropdown>
            </div>
            <div class="page-title">双暖孝亲数智化服务调度中心</div>
            <div class="flex align-center">
                <div class="btn-container max right margin-left-sm">
                    <div class="btn">{{ cur_time|date_time }}</div>
                </div>

            </div>
        </div>
        <div class="content-container flex flex-direction flex-sub">
            <div class="info-container total-container flex align-center">
                <div class="total-item flex align-center" v-if="total.jumin_equipment_num_style">
                    <img class="image" src="../../../assets/img/data/icon_service_info_total_1.png">
                    <div class="flex flex-direction">
                        <div class="flex">
                            <dv-digital-flop :config="{style:style,number:[total.jumin_equipment_num],content:'{nt}'}"
                                             class="number" :style="total.jumin_equipment_num_style"/>
                            <div class="label self-end">名</div>
                        </div>
                        <div class="title">认证服务对象</div>
                    </div>
                </div>
                <div class="total-item flex align-center" v-if="total.jumin_equipment_num_style">
                    <img class="image" src="../../../assets/img/data/icon_service_info_total_2.png">
                    <div class="flex flex-direction">
                        <div class="flex">
                            <dv-digital-flop :config="{style:style,number:[total.yesterday_save_order_num],content:'{nt}'}"
                                             class="number" :style="total.yesterday_save_order_num_style"/>
                            <div class="label self-end">人次</div>
                        </div>
                        <div class="title">昨日预警总数</div>
                    </div>
                </div>
                <div class="total-item flex align-center" v-if="total.jumin_equipment_num_style">
                    <img class="image" src="../../../assets/img/data/icon_service_info_total_2.png">
                    <div class="flex flex-direction">
                        <div class="flex">
                            <dv-digital-flop :config="{style:style,number:[total.today_save_order_num],content:'{nt}'}"
                                             class="number" :style="total.today_save_order_num_style"/>
                            <div class="label self-end">人次</div>
                        </div>
                        <div class="title">今日预警总数</div>
                    </div>
                </div>
                <div class="total-item flex align-center" v-if="total.jumin_equipment_num_style">
                    <img class="image" src="../../../assets/img/data/icon_service_info_total_2.png">
                    <div class="flex flex-direction">
                        <div class="flex">
                            <dv-digital-flop :config="{style:style,number:[total.save_order_num],content:'{nt}'}"
                                             class="number" :style="total.save_order_num_style"/>
                            <div class="label self-end">次</div>
                        </div>
                        <div class="title">总预警次数</div>
                    </div>
                </div>
                <div class="total-item flex align-center" v-if="total.jumin_equipment_num_style">
                    <img class="image" src="../../../assets/img/data/icon_service_info_total_3.png">
                    <div class="flex flex-direction">
                        <div class="flex">
                            <dv-digital-flop :config="{style:style,number:[total.push_num],content:'{nt}'}"
                                             class="number" :style="total.push_num_style"/>
                            <div class="label self-end">次</div>
                        </div>
                        <div class="title">总监测次数</div>
                    </div>
                </div>
            </div>

            <div class="flex margin-top-sm">
                <div class="info-container health-container max flex flex-direction">
                    <div class="classify-title self-center">健康守护</div>
                    <router-link class="more" :to="`/digitize/monitoring_watcher${project_id ? `?xiangmu_id=${project_id}` : ''}`">
                        查看详细<i class="el-icon-arrow-right"></i></router-link>
                    <div class="flex flex-wrap justify-between">
                        <div class="health-item flex flex-direction">
                            <div class="flex align-center self-center">
                                <img class="image" src="../../../assets/img/data/icon_service_info_health_1.png">
                                <div class="title">血氧异常报警</div>
                            </div>
                            <div class="number-container flex align-center justify-center">
                                <div class="number-item flex flex-direction">
                                    <div class="name">今日</div>
                                    <div class="flex">
                                        <dv-digital-flop :config="{style:min_style,number:[total.today_xueyang_order_num],content:'{nt}'}"
                                                         class="number"/>
                                        <div class="label">次</div>
                                    </div>
                                </div>
                                <div class="number-item flex flex-direction">
                                    <div class="name">总计</div>
                                    <div class="flex">
                                        <dv-digital-flop :config="{style:min_blue_style,number:[total.xueyang_order_num],content:'{nt}'}"
                                                         class="number"/>
                                        <div class="label">次</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="health-item flex flex-direction">
                            <div class="flex align-center self-center">
                                <img class="image" src="../../../assets/img/data/icon_service_info_health_2.png">
                                <div class="title">血压异常报警</div>
                            </div>
                            <div class="number-container flex align-center justify-center">
                                <div class="number-item flex flex-direction">
                                    <div class="name">今日</div>
                                    <div class="flex">
                                        <dv-digital-flop :config="{style:min_style,number:[total.today_xueya_order_num],content:'{nt}'}"
                                                         class="number"/>
                                        <div class="label">次</div>
                                    </div>
                                </div>
                                <div class="number-item flex flex-direction">
                                    <div class="name">总计</div>
                                    <div class="flex">
                                        <dv-digital-flop :config="{style:min_blue_style,number:[total.xueya_order_num],content:'{nt}'}"
                                                         class="number"/>
                                        <div class="label">次</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="health-item flex flex-direction">
                            <div class="flex align-center self-center">
                                <img class="image" src="../../../assets/img/data/icon_service_info_health_3.png">
                                <div class="title">心率异常报警</div>
                            </div>
                            <div class="number-container flex align-center justify-center">
                                <div class="number-item flex flex-direction">
                                    <div class="name">今日</div>
                                    <div class="flex">
                                        <dv-digital-flop :config="{style:min_style,number:[total.today_xinlv_order_num],content:'{nt}'}"
                                                         class="number"/>
                                        <div class="label">次</div>
                                    </div>
                                </div>
                                <div class="number-item flex flex-direction">
                                    <div class="name">总计</div>
                                    <div class="flex">
                                        <dv-digital-flop :config="{style:min_blue_style,number:[total.xinlv_order_num],content:'{nt}'}"
                                                         class="number"/>
                                        <div class="label">次</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="health-item flex flex-direction">
                            <div class="flex align-center self-center">
                                <img class="image" src="../../../assets/img/data/icon_service_info_health_4.png">
                                <div class="title">体温异常报警</div>
                            </div>
                            <div class="number-container flex align-center justify-center">
                                <div class="number-item flex flex-direction">
                                    <div class="name">今日</div>
                                    <div class="flex">
                                        <dv-digital-flop :config="{style:min_style,number:[total.today_tiwen_order_num],content:'{nt}'}"
                                                         class="number"/>
                                        <div class="label">次</div>
                                    </div>
                                </div>
                                <div class="number-item flex flex-direction">
                                    <div class="name">总计</div>
                                    <div class="flex">
                                        <dv-digital-flop :config="{style:min_blue_style,number:[total.tiwen_order_num],content:'{nt}'}"
                                                         class="number"/>
                                        <div class="label">次</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="info-container map-container flex-sub">
                    <img class="image" src="../../../assets/img/data/icon_service_info_map.png">
                </div>
                <div class="info-container family-container max flex flex-direction">
                    <div class="classify-title self-center">亲情守护</div>
                    <router-link class="more" :to="`/digitize/service_flove${project_id ? `?xiangmu_id=${project_id}` : ''}`">
                        查看详细<i class="el-icon-arrow-right"></i></router-link>
                    <div class="flex flex-wrap justify-between">
                        <div class="family-item flex flex-direction">
                            <div class="number-container flex align-center justify-center">
                                <div class="number-item flex flex-direction">
                                    <div class="name">今日</div>
                                    <div class="flex">
                                        <div class="number">{{ total.today_shengri_num }}</div>
                                        <div class="label">次</div>
                                    </div>
                                </div>
                                <div class="number-item flex flex-direction">
                                    <div class="name">总计</div>
                                    <div class="flex">
                                        <div class="number blue">{{ total.total_shengri_num }}</div>
                                        <div class="label">次</div>
                                    </div>
                                </div>
                            </div>
                            <div class="flex align-center justify-between margin-top-xs">
                                <div class="title">生日慰问</div>
                                <img class="image" src="../../../assets/img/data/icon_service_info_family_1.png">
                            </div>
                        </div>
                        <div class="family-item flex flex-direction">
                            <div class="number-container flex align-center justify-center">
                                <div class="number-item flex flex-direction">
                                    <div class="name">今日</div>
                                    <div class="flex">
                                        <div class="number">{{ total.today_jieri_num }}</div>
                                        <div class="label">次</div>
                                    </div>
                                </div>
                                <div class="number-item flex flex-direction">
                                    <div class="name">总计</div>
                                    <div class="flex">
                                        <div class="number blue">{{ total.total_jieri_num }}</div>
                                        <div class="label">次</div>
                                    </div>
                                </div>
                            </div>
                            <div class="flex align-center justify-between margin-top-xs">
                                <div class="title">节日庆祝</div>
                                <img class="image" src="../../../assets/img/data/icon_service_info_family_2.png">
                            </div>
                        </div>
                        <div class="family-item flex flex-direction">
                            <div class="number-container flex align-center justify-center">
                                <div class="number-item flex flex-direction">
                                    <div class="name">今日</div>
                                    <div class="flex">
                                        <div class="number">{{ total.today_jieqi_num }}</div>
                                        <div class="label">次</div>
                                    </div>
                                </div>
                                <div class="number-item flex flex-direction">
                                    <div class="name">总计</div>
                                    <div class="flex">
                                        <div class="number blue">{{ total.total_jieqi_num }}</div>
                                        <div class="label">次</div>
                                    </div>
                                </div>
                            </div>
                            <div class="flex align-center justify-between margin-top-xs">
                                <div class="title">节气提醒</div>
                                <img class="image" src="../../../assets/img/data/icon_service_info_family_3.png">
                            </div>
                        </div>
                        <div class="family-item flex flex-direction">
                            <div class="number-container flex align-center justify-center">
                                <div class="number-item flex flex-direction">
                                    <div class="name">今日</div>
                                    <div class="flex">
                                        <div class="number">{{ total.today_tianqi_num }}</div>
                                        <div class="label">次</div>
                                    </div>
                                </div>
                                <div class="number-item flex flex-direction">
                                    <div class="name">总计</div>
                                    <div class="flex">
                                        <div class="number blue">{{ total.total_tianqi_num }}</div>
                                        <div class="label">次</div>
                                    </div>
                                </div>
                            </div>
                            <div class="flex align-center justify-between margin-top-xs">
                                <div class="title">天气提醒</div>
                                <img class="image" src="../../../assets/img/data/icon_service_info_family_4.png">
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="flex margin-top-sm">
                <div class="info-container state-container min flex flex-direction">
                    <div class="classify-title self-center">活力守护</div>
                    <router-link class="more" target="_blank" :to="`/digitize/all?xiangmu_id=${project_id || 0}`">
                        查看详细<i class="el-icon-arrow-right"></i></router-link>
                    <div id="state_echarts" class="echarts"></div>
                </div>
                <div class="info-container yj-total-container flex flex-direction flex-sub">
                    <div class="classify-title self-center">预警列表</div>
                    <div class="operate-container flex align-center justify-between">
                        <div class="operate" @click="yibanRefresh"><i class="iconfont icon-shuaxin"></i> 刷新</div>
                        <div class="flex align-center">
                            <div class="operate" @click="yibanLast">上一页</div>
                            <div class="page">{{ yj_yiban_page }}/{{ yj_yiban_total_page }}</div>
                            <div class="operate" @click="yibanNext">下一页</div>
                        </div>
                    </div>
                    <div class="flex flex-wrap justify-between margin-top-xs">
                        <div class="yj-item flex align-center" :class="item.state === 3 ? 'error' : 'warn'"
                             v-for="(item,index) in yj_yiban_list" :key="index">
                            <div class="tip-container flex flex-direction justify-center align-center">
                                <div class="tip">{{ item.service_type|service_type }}</div>
                            </div>
                            <div class="flex flex-direction">
                                <div class="flex align-center">
                                    <div class="name" v-if="item.show_name">{{ item.name }}</div>
                                    <div class="name" @click="item.show_name = true" v-else>{{ item.name | formatName }}</div>
                                    <div class="phone margin-left-xs" v-if="item.show_phone">{{ item.phone }}</div>
                                    <div class="phone margin-left-xs" @click="item.show_phone = true" v-else>{{ item.phone | phone_format }}</div>
                                </div>
                                <div class="address">{{ item.xiaoqu_name }}
                                    <span v-if="item.show_address">{{ item.building_name
                                        }}{{ item.element_name }}单元{{ item.room_name }}</span>
                                    <span  @click="item.show_address = true" v-else>****</span>
                                </div>
                            </div>
                            <div class="time">{{ item.add_time }}</div>
                        </div>
                    </div>

                </div>
                <div class="info-container safety-container min flex flex-direction">
                    <div class="classify-title self-center">安全守护</div>
                    <router-link class="more" :to="`/digitize/service_safety${project_id ? `?xiangmu_id=${project_id}` : ''}`">
                        查看详细<i class="el-icon-arrow-right"></i></router-link>
                    <div class="flex flex-wrap justify-between">
                        <div class="safety-item-v2 flex flex-direction">
                            <div class="flex align-center self-center">
                                <i class="icon iconfont icon-dian"></i>
                                <div class="title">漏电警报</div>
                            </div>
                            <div class="flex align-center justify-between margin-top-sm">
                                <div class="number-item flex flex-direction align-center justify-center">
                                    <div class="number">{{ total.electricity_num }}</div>
                                    <div class="label">正常</div>
                                </div>
                                <div class="number-item flex flex-direction align-center justify-center">
                                    <div class="number error">{{ total.electricity_order_num }}</div>
                                    <div class="label">异常</div>
                                </div>
                            </div>
                        </div>
                        <div class="safety-item-v2 flex flex-direction">
                            <div class="flex align-center self-center">
                                <i class="icon iconfont icon-shenghuoshuibengfang"></i>
                                <div class="title">水感警报</div>
                            </div>
                            <div class="flex align-center justify-between margin-top-sm">
                                <div class="number-item flex flex-direction align-center justify-center">
                                    <div class="number">{{ total.water_num }}</div>
                                    <div class="label">正常</div>
                                </div>
                                <div class="number-item flex flex-direction align-center justify-center">
                                    <div class="number error">{{ total.water_order_num }}</div>
                                    <div class="label">异常</div>
                                </div>
                            </div>
                        </div>
                        <div class="safety-item-v2 flex flex-direction">
                            <div class="flex align-center self-center">
                                <i class="icon iconfont icon-firealarmcopy"></i>
                                <div class="title">烟感警报</div>
                            </div>
                            <div class="flex align-center justify-between margin-top-sm">
                                <div class="number-item flex flex-direction align-center justify-center">
                                    <div class="number">{{ total.smoke_num }}</div>
                                    <div class="label">正常</div>
                                </div>
                                <div class="number-item flex flex-direction align-center justify-center">
                                    <div class="number error">{{ total.smoke_order_num }}</div>
                                    <div class="label">异常</div>
                                </div>
                            </div>
                        </div>
                        <div class="safety-item-v2 max flex flex-direction">
                            <div class="flex align-center self-center">
                                <i class="icon iconfont icon-dianchi-chongdian"></i>
                                <div class="title">充电过载警报</div>
                            </div>
                            <div class="flex align-center justify-between margin-top-sm">
                                <div class="number-item flex flex-direction align-center justify-center">
                                    <div class="number">{{ total.charge_num }}</div>
                                    <div class="label">正常</div>
                                </div>
                                <div class="number-item flex flex-direction align-center justify-center">
                                    <div class="number error">{{ total.charge_order_num }}</div>
                                    <div class="label">异常</div>
                                </div>
                            </div>
                        </div>
                        <div class="safety-item-v2 max flex flex-direction">
                            <div class="flex align-center self-center">
                                <i class="icon iconfont icon-Pilates"></i>
                                <div class="title">摔倒警报</div>
                            </div>
                            <div class="flex align-center justify-between margin-top-sm">
                                <div class="number-item flex flex-direction align-center justify-center">
                                    <div class="number">{{ total.fall_num }}</div>
                                    <div class="label">正常</div>
                                </div>
                                <div class="number-item flex flex-direction align-center justify-center">
                                    <div class="number error">{{ total.fall_order_num }}</div>
                                    <div class="label">异常</div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--                    <div class="safety-item flex align-center justify-between">-->
                    <!--                        <div class="flex align-center">-->
                    <!--                            <i class="icon iconfont icon-dian"></i>-->
                    <!--                            <div class="title">漏电警报</div>-->
                    <!--                        </div>-->
                    <!--                        <div class="flex align-center">-->
                    <!--                            <div class="number-item flex flex-direction align-center justify-center">-->
                    <!--                                <div class="number">302</div>-->
                    <!--                                <div class="label">正常</div>-->
                    <!--                            </div>-->
                    <!--                            <div class="number-item flex flex-direction align-center justify-center">-->
                    <!--                                <div class="number error">302</div>-->
                    <!--                                <div class="label">异常</div>-->
                    <!--                            </div>-->
                    <!--                        </div>-->
                    <!--                    </div>-->
                    <!--                    <div class="safety-item flex align-center justify-between">-->
                    <!--                        <div class="flex align-center">-->
                    <!--                            <i class="icon iconfont icon-shenghuoshuibengfang"></i>-->
                    <!--                            <div class="title">水感警报</div>-->
                    <!--                        </div>-->
                    <!--                        <div class="flex align-center">-->
                    <!--                            <div class="number-item flex flex-direction align-center justify-center">-->
                    <!--                                <div class="number">361</div>-->
                    <!--                                <div class="label">正常</div>-->
                    <!--                            </div>-->
                    <!--                            <div class="number-item flex flex-direction align-center justify-center">-->
                    <!--                                <div class="number error">7</div>-->
                    <!--                                <div class="label">异常</div>-->
                    <!--                            </div>-->
                    <!--                        </div>-->
                    <!--                    </div>-->
                    <!--                    <div class="safety-item flex align-center justify-between">-->
                    <!--                        <div class="flex align-center">-->
                    <!--                            <i class="icon iconfont icon-dianchi-chongdian"></i>-->
                    <!--                            <div class="title">充电过载警报</div>-->
                    <!--                        </div>-->
                    <!--                        <div class="flex align-center">-->
                    <!--                            <div class="number-item flex flex-direction align-center justify-center">-->
                    <!--                                <div class="number">631</div>-->
                    <!--                                <div class="label">正常</div>-->
                    <!--                            </div>-->
                    <!--                            <div class="number-item flex flex-direction align-center justify-center">-->
                    <!--                                <div class="number error">29</div>-->
                    <!--                                <div class="label">异常</div>-->
                    <!--                            </div>-->
                    <!--                        </div>-->
                    <!--                    </div>-->


                </div>
            </div>
        </div>

        <safety-yujing-dialog :dialog="safetyYujingDialog" :detail="cur_item" @cancelDialog="cancelSafetyDialog"></safety-yujing-dialog>

        <yijing-dialog :dialog="yijingDialog" :detail="cur_detail" @cancelDialog="cancelDialog"></yijing-dialog>
    </div>
</template>

<script>

import {filesCNOher, formatName, formatPhone, zhDate} from "@/utils/utils";
import {dataScreenXiaoQin, getSaveDeviceList, getSaveList} from "@/api/tongji";
import * as echarts from 'echarts';
import {getXiangMuList} from "@/api/common";
import SafetyYujingDialog from "@/views/digitize/components/SafetyYujingDialog";
import YijingDialog from "@/views/digitize/components/YijingDialog";

export default {
    name: "service_info",
    components: {YijingDialog, SafetyYujingDialog},
    data() {
        return {
            mapImg: '',
            cur_time: new Date().getTime(),
            style: {
                fontSize: 26,
                fill: '#ffd200',
                fontFamily: 'PingFang SC',
                fontWeight: 'bold',
                FontStyle: 'italic'
            },
            min_style: {
                width: '120px',
                fontSize: 20,
                fill: '#ffd200',
                fontFamily: 'PingFang SC',
                fontWeight: 'bold',
                FontStyle: 'italic'
            },
            min_blue_style: {
                width: '120px',
                fontSize: 20,
                fill: '#15b3e7',
                fontFamily: 'PingFang SC',
                fontWeight: 'bold',
                FontStyle: 'italic'
            },

            loading: false,
            total: {
                jumin_equipment_num: 0,
                push_num: 0,
                save_order_num: 0,
                tiwen_order_num: 0,
                today_save_order_num: 0,
                today_tiwen_order_num: 0,
                today_xinlv_order_num: 0,
                today_xueya_order_num: 0,
                today_xueyang_order_num: 0,
                xinlv_order_num: 0,
                xueya_order_num: 0,
                xueyang_order_num: 0,
                yesterday_save_order_num: 0,

                charge_num: 0,
                charge_order_num: 0,
                electricity_num: 0,
                electricity_order_num: 0,
                fall_num: 0,
                fall_order_num: 0,
                smoke_num: 0,
                smoke_order_num: 0,
                water_num: 0,
                water_order_num: 0,

                total_jieqi_num: 0,
                total_jieri_num: 0,
                total_shengri_num: 0,
                total_tianqi_num: 0,
                sleep_time_minute: 0,
            },

            yj_yiban_list: [],
            yj_yiban_page: 1,
            yj_yiban_total_page: 1,
            state_option: {
                animationDuration: 2000,
                animationEasing: 'cubicOut',
                grid: {
                    bottom: 30,
                    right: 30,
                    top: 30
                },
                xAxis: {
                    data: [],
                    axisTick: {
                        show: false //去除刻度线
                    },
                    axisLabel: {
                        rotate: 0,
                        color: '#fff',
                        fontSize: 10
                    },
                    axisLine: {
                        show: true, //去除轴线
                        lineStyle: {
                            color: '#fff',
                            width: 2
                        }
                    },

                },
                yAxis: {
                    type: 'value',
                    minInterval: 1,
                    axisLabel: {
                        color: '#fff',
                        fontSize: 10
                    },
                    axisTick: {
                        show: false //去除刻度线
                    },
                    splitLine: {
                        lineStyle: {
                            color: '#fff1',
                        }
                    },
                    axisLine: {
                        show: false, //去除轴线
                        lineStyle: {
                            color: '#fff',
                            width: 2
                        }
                    },
                },
                series: {
                    data: [],
                    type: 'bar',
                    barWidth: 21,
                    label: {
                        show: false,
                        position: 'top',
                        valueAnimation: true,
                        color: '#fff'
                    },
                    itemStyle: {
                        borderRadius: [6, 6, 0, 0], //（顺时针左上，右上，右下，左下）
                        color: {
                            type: 'linear',
                            x: 0,
                            y: 0,
                            x2: 0,
                            y2: 1,
                            colorStops: [{
                                offset: 1, color: '#009cff' // 0% 处的颜色
                            }, {
                                offset: 0, color: '#00eaff' // 100% 处的颜色
                            }],
                            global: false // 缺省为 false
                        }
                    }

                }
            },
            project_id: '',
            project_name: '',
            projects: [{id: 0, name: '全部社区'}],
            cur_item: '',
            safetyYujingDialog: false,
            yijingDialog:false,
            cur_detail:''
        }
    },
    computed: {
        user() {
            return this.$store.state.user
        },
    },
    created() {
        this.project_id = this.$route.query.xiangmu_id
        this.getCurrentTime()
    },
    mounted() {
        this.onload()
    },
    methods: {
        onload() {
            this.loading = true
            this.init()
            if (this.user.power === 3) this.getXiangMuList()
            this.getYibanSaveList()
            this.getSaveDeviceList()
            this.getJinjiSaveList()
            this.setTimeoutGetData()
        },
        async getXiangMuList() {
            let _data = await getXiangMuList()
            this.projects = [...this.projects, ..._data.data]
            if (this.project_id) this.project_name = filesCNOher(Number(this.project_id), this.projects)
        },
        handleCommand(item) {
            this.project_id = item.id
            this.project_name = item.name
            history.replaceState('', '', window.location.origin + window.location.pathname + `${this.project_id ? `?xiangmu_id=${this.project_id}` : ''}`)
            this.total.jumin_equipment_num_style = ''
            this.loading = true
            this.init()
            this.getYibanSaveList()
        },
        setTimeoutGetData() {
            setInterval(() => {
                this.init()
                this.getYibanSaveList()
                this.getSaveDeviceList()
                this.getJinjiSaveList()
            }, 1000 * 60)
        },
        async getSaveDeviceList() {
            let _data = await getSaveDeviceList(this.xiaoqu_id, '',1, 6, this.project_id)
            _data.data.map(item => {
                item.show_phone = false
                item.show_address = false
                let _info = item.emergency_contact.split('-')
                if (_info.length) {
                    item.name = _info[0]
                    item.phone = _info[1]
                }
            })
            let filter = _data.data.filter(f => {
                return f.state === 2
            });
            // let filter = this.yj_yiban_list.filter(f=>{ return f.is_read === 0});
            if (filter.length) {
                this.cur_item = filter[0]
                this.safetyYujingDialog = true
            }
        },
        async getJinjiSaveList() {
            let _data = await getSaveList(this.xiaoqu_id, 3, 1, 4,this.project_id)
            _data.data.map(item=>{
                item.show_phone = false
                item.show_address = false
            })
            let filter = _data.data.filter(f=>{ return f.state === 2});
            if (filter.length){
                this.cur_detail = filter[0]
                this.yijingDialog = true
            }
        },
        cancelDialog(data){
            this.yijingDialog = false
        },
        cancelSafetyDialog(data){
            this.safetyYujingDialog = false
        },
        async getYibanSaveList() {
            let _data = await getSaveList(this.xiaoqu_id, '', this.yj_yiban_page, 6, this.project_id)
            _data.data.map(item=>{
                item.show_phone = false
                item.show_address = false
            })
            this.yj_yiban_total_page = _data.total_page
            this.yj_yiban_list = _data.data
        },
        yibanLast() {
            if (this.yj_yiban_page <= 1) return
            this.yj_yiban_page--
            this.getYibanSaveList()
        },
        yibanNext() {
            if (this.yj_yiban_page === this.yj_yiban_total_page) return
            this.yj_yiban_page++
            this.getYibanSaveList()
        },
        yibanRefresh() {
            this.yj_yiban_page = 1
            this.getYibanSaveList()
        },
        //  获取数据
        async init() {
            let _data = await dataScreenXiaoQin(this.project_id)
            _data.data.jumin_equipment_num_style = this.getStyle(_data.data.jumin_equipment_num)
            _data.data.save_order_num_style = this.getStyle(_data.data.save_order_num)
            _data.data.today_save_order_num_style = this.getStyle(_data.data.today_save_order_num)
            _data.data.yesterday_save_order_num_style = this.getStyle(_data.data.yesterday_save_order_num)
            _data.data.push_num_style = this.getStyle(_data.data.push_num)
            let state_echarts = echarts.init(document.getElementById('state_echarts'))
            this.state_option.xAxis.data = _data.data.service_arr.map(item => {
                return item.name
            })
            this.state_option.series.data = _data.data.service_arr.map(item => {
                return item.num
            })
            state_echarts.setOption(this.state_option)
            this.total = _data.data
            this.loading = false
        },
        getCurrentTime() {
            setInterval(() => {
                this.cur_time = new Date().getTime()
            }, 1000)
        },
        getStyle(num, size = 16) {
            return `width:${num.toString().length * size}px`
        }
    },
    filters: {
        date_time(val) {
            return zhDate(val, 8)
        },
        service_type(val) {
            switch (Number(val)) {
                case 1 :
                    return '主动求救'
                case 2 :
                    return '心率异常'
                case 3 :
                    return '体温异常'
                case 4 :
                    return '血糖异常'
                case 5 :
                    return '血氧异常'
                case 6 :
                    return '血压异常'
            }
        },
        phone_format(val) {
            return formatPhone(val)
        },
        formatName(val) {
            return formatName(val)
        }
    }
}
</script>

<style lang="scss" scoped>

.container {
    height: 100vh;
    min-width: 1920px;
    min-height: 1080px;
    overflow: hidden;

    .loading {
        color: #ffffff;
        position: fixed;
        background: #33333333;
        z-index: 10;
    }

    .header-container {
        background: url(../../../assets/img/data/bg_monitoring.png) no-repeat top;
        background-size: 100% 100%;
        height: 102px;
        position: relative;
        padding: 0 36px;

        .page-title {
            position: absolute;
            left: 50%;
            top: 50%;
            transform: translate(-50%, -50%);
            font-size: 36px;
            font-weight: 600;
            color: #ffffff;
        }

        .btn-container {
            transform: skew(25deg);
            width: 152px;
            height: 48px;
            min-width: 137px;
            line-height: 48px;
            box-shadow: inset 0px 0px 8px 3px #0096ff;
            background-color: #173979;
            text-align: center;
            font-size: 18px;
            color: #19caff;
            font-weight: 500;
            cursor: pointer;

            &.right {
                transform: skew(-25deg);

                .btn {
                    transform: skew(25deg);
                }
            }

            .btn {
                transform: skew(-25deg);
            }

            &.max {
                width: 282px;
            }

            &.mid {
                width: 182px;
            }
        }


    }

    .content-container {
        box-shadow: inset -10px 20px 18px -20px #0096ff;
        background-color: #173979;
        padding: 26px;


        .info-container {
            box-shadow: inset 0px 0px 8px 3px #0096ff;
            background-image: linear-gradient(0deg,
                #0c5da399 0%,
                #00226299 100%);
            background-blend-mode: normal,
            normal;
            position: relative;

            .more {
                color: #0096ff;
                font-size: 12px;
                position: absolute;
                right: 20px;
                top: 20px;
                cursor: pointer;
            }

            .classify-title {
                background: url(../../../assets/img/data/bg_monitoring_title.png) no-repeat top;
                background-size: 100% 100%;
                width: 242px;
                height: 41px;
                line-height: 41px;
                text-align: center;
                font-size: 18px;
                font-weight: 600;
                color: #19caff;
            }

            &.max {
                width: 495px;
                height: 415px;
            }

            &.min {
                width: 495px;
                height: 342px;
            }

            &.safety-container {
                padding: 0 21px;

                .safety-item-v2 {
                    background-color: #00226266;
                    border-radius: 10px;
                    border: solid 1px #19caff55;
                    margin-top: 12px;
                    width: 139px;
                    padding: 18px 6px;

                    &.max {
                        width: 218px;

                        .number-item {
                            width: 96px;
                        }
                    }

                    .icon {
                        font-size: 28px;
                        color: #19caff;
                    }

                    .title {
                        font-size: 16px;
                        color: #ffffff;
                        margin-left: 8px;

                    }

                    .number-item {
                        width: 60px;
                        height: 53px;
                        background-color: #0e6cb433;
                        border-radius: 10px;

                        .number {
                            font-size: 18px;
                            font-weight: 600;
                            font-style: italic;
                            color: #15b3e7;

                            &.error {
                                color: #ff6767;
                            }
                        }

                        .label {
                            font-size: 14px;
                            color: #ffffff;
                        }
                    }


                }

                .safety-item {
                    height: 78px;
                    background-color: #00226266;
                    border-radius: 10px;
                    border: solid 1px #19caff55;
                    padding: 0 12px;
                    margin-top: 12px;

                    .icon {
                        font-size: 28px;
                        color: #19caff;
                    }

                    .title {
                        font-size: 20px;
                        color: #ffffff;
                        margin-left: 12px;
                    }

                    .number-item + .number-item {
                        margin-left: 12px;
                    }

                    .number-item {
                        width: 101px;
                        height: 61px;
                        background-color: #0e6cb433;
                        border-radius: 10px;

                        .number {
                            font-size: 22px;
                            font-weight: 600;
                            font-style: italic;
                            color: #15b3e7;

                            &.error {
                                color: #ff6767;
                            }
                        }

                        .label {
                            font-size: 16px;
                            color: #ffffff;
                        }
                    }
                }
            }

            &.yj-total-container {
                padding: 0 37px;
                margin: 0 12px;
                position: relative;

                .operate-container {
                    position: absolute;
                    top: 22px;
                    left: 37px;
                    right: 37px;

                    .operate {
                        width: 71px;
                        height: 28px;
                        line-height: 28px;
                        text-align: center;
                        box-shadow: inset 0px 0px 8px 3px #0096ff;
                        font-size: 14px;
                        color: #19caff;
                        cursor: pointer;
                    }

                    .page {
                        width: 71px;
                        font-size: 14px;
                        text-align: center;
                        color: #19caff;
                    }
                }


                .yj-item {
                    width: calc(100% / 2 - 30px);
                    height: 79px;
                    background-color: #173979;
                    border-radius: 5px;
                    margin-top: 10px;
                    margin-left: 13px;
                    position: relative;
                    padding-left: 74px;

                    &.warn {
                        .time {
                            color: #ffbe41;
                        }

                        .tip-container {
                            background-color: #ffbe41;

                            .status {
                                background-color: #ffbe41;
                                color: #FFFFFF;
                            }
                        }
                    }

                    &.error {
                        .time {
                            color: #ff576f;
                        }

                        .tip-container {
                            background-color: #ff576f;

                            .status {
                                background-color: #e6334c;
                                color: #FFFFFF;
                            }
                        }
                    }

                    .tip-container {
                        position: absolute;
                        width: 73px;
                        height: 63px;
                        background-color: #19caff;
                        border-radius: 5px;
                        top: 50%;
                        left: -13px;
                        transform: translateY(-50%);

                        .tip {
                            font-size: 16px;
                            color: #ffffff;
                            font-weight: 600;
                        }
                    }

                    .name {
                        font-size: 18px;
                        font-weight: 600;
                        color: #ffffff;
                    }

                    .phone, .address {
                        font-size: 14px;
                        color: #b1c5eb;
                    }

                    .time {
                        position: absolute;
                        right: 10px;
                        top: 0px;
                        font-size: 12px;
                        color: #19caff;
                    }
                }
            }

            &.state-container {
                .echarts {
                    width: 450px;
                    height: 300px;
                }
            }

            &.map-container {
                margin: 0 12px;

                .image {
                    width: 100%;
                    height: 415px;
                    object-fit: cover;
                }
            }

            &.family-container {
                padding: 0 23px;

                .family-item {
                    width: 219px;
                    height: 160px;
                    background-color: #00226266;
                    border-radius: 10px;
                    border: solid 1px #19caff55;
                    padding: 16px;
                    margin-top: 20px;

                    .title {
                        font-size: 18px;
                        color: #ffffff;
                    }

                    .image {
                        height: 49px;
                    }

                    .number-container {
                        position: relative;
                        width: 100%;
                        height: 78px;

                        &::before {
                            width: 100%;
                            height: 1.5px;
                            background: #129bd455;
                            position: absolute;
                            content: '';
                            bottom: 0;
                            left: 0;
                            right: 0;
                        }

                        .number-item + .number-item {
                            border-left: 1px solid #129bd455;
                        }

                        .number-item {
                            flex: 1;
                            justify-content: center;
                            align-items: center;

                            .name {
                                font-size: 14px;
                                color: #fefefe;
                                margin-bottom: 5px;
                            }

                            .label {
                                font-size: 12px;
                                color: #fefefe;
                                margin-top: 3px;
                                margin-left: 3px;
                            }

                            .number {
                                font-size: 22px;
                                font-weight: 600;
                                color: #c19bff;

                                &.blue {
                                    color: #15b3e7;
                                }
                            }
                        }
                    }
                }
            }

            &.health-container {
                padding: 0 23px;

                .health-item {
                    width: 219px;
                    height: 160px;
                    background-color: #00226266;
                    border-radius: 10px;
                    border: solid 1px #19caff55;
                    padding: 16px 10px;
                    margin-top: 20px;

                    .image {
                        height: 25px;
                    }

                    .title {
                        font-size: 18px;
                        color: #ffffff;
                    }

                    .number-container {
                        background: linear-gradient(90deg, #ffffff01 0%, #ffffff01 10%, #062b66 50%, #ffffff01 90%, #ffffff01 100%);
                        background-blend-mode: normal, normal;
                        position: relative;
                        width: 100%;
                        height: 78px;
                        margin-top: 18px;

                        &::after {
                            width: 100%;
                            height: 1px;
                            background: linear-gradient(70deg, #19caff33 0%, #1b85bf 30%, #19caff 50%, #1b85bf 80%, #19caff33 100%);
                            position: absolute;
                            content: '';
                            top: 0;
                            left: 0;
                            right: 0;
                        }

                        &::before {
                            width: 100%;
                            height: 1.5px;
                            background: linear-gradient(70deg, #19caff33 0%, #1b85bf 30%, #19caff 50%, #1b85bf 80%, #19caff33 100%);
                            position: absolute;
                            content: '';
                            bottom: 0;
                            left: 0;
                            right: 0;
                        }

                        .number-item + .number-item {
                            border-left: 1px solid #129bd455;
                        }

                        .number-item {
                            flex: 1;
                            justify-content: center;
                            align-items: center;

                            .name {
                                font-size: 14px;
                                color: #fefefe;
                                margin-bottom: 5px;
                            }

                            .label {
                                font-size: 12px;
                                color: #fefefe;
                                margin-top: 3px;
                            }

                            .number {
                                height: 20px;
                            }
                        }
                    }
                }
            }

            &.total-container {
                width: 100%;
                height: 128px;

                .total-item + .total-item {
                    border-left: 1px solid #10a6f555;
                }

                .total-item {
                    flex: 1;

                    .image {
                        width: 64px;
                        height: 64px;
                        margin-left: 80px;
                        margin-right: 20px;
                    }

                    .label {
                        font-size: 14px;
                        color: #ffffff;
                        margin-top: 3px;
                        margin-left: 5px;
                    }

                    .number {
                        height: 26px;
                    }

                    .title {
                        font-size: 16px;
                        color: #ffffff;
                        margin-top: 12px;
                    }
                }
            }
        }


    }
}
</style>
